import React from "react";
import { Button, Container } from "react-bootstrap";
import AppComponent from "../../../Components/AppComponent";

import SearchBox from "../../../Components/Input/SearchBox";
import ItemList from "../../Components/ItemList";
import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import api from "../../../Services/Api/api";
import EditExpense from "./EditExpense";
import NavBar from "../../Components/NavBar";
import ConfirmationModal from "../../../Components/Models/confirmation-modal";
import RenderAmount from "../../../Components/etc/RenderAmount";

const SCREEN_NAME = "EXPENSES_SCREEN";

class ExpensesScreen extends AppComponent {
  state = {
    visibleModal: null,
    modalData: null,
    triggerReload: 0,
  };

  additionalQueries = {};

  columns = [
    {
      value: "t",
      label: "Date",
      render: ({ item }) => new Date(item.t).toLocaleString(),
    },
    {
      value: "label",
      label: "Label",
    },
    {
      value: "amount",
      label: "Amount",
      render: ({ item }) => <RenderAmount value={item.amount?.toFixed?.(2)} />,
    },

    {
      value: "note",
      label: "Note",
      render: ({ item }) => <div className="multiline">{item.note}</div>,
    },
    {
      value: "actions",
      label: "Actions",
      render: ({ item }) => (
        <>
          <Button
            variant="secondary"
            onClick={() =>
              this.setAsyncState({
                visibleModal: "editExpense",
                modalData: { expense: item },
              })
            }
          >
            Edit
          </Button>{" "}
          <Button
            variant="secondary"
            onClick={() =>
              this.setAsyncState({
                visibleModal: "deleteExpense",
                modalData: { expense: item },
              })
            }
          >
            Delete
          </Button>
        </>
      ),
    },
  ];

  async retriveData(query) {
    const { expenses } = await api.get("v1/expense", query);
    return expenses;
  }

  async setItems(items) {
    this.props.setScreenState({ expenses: items });
  }

  onNewExpense(item) {
    this.setAsyncState({
      visibleModal: null,
      modalData: null,
      triggerReload: Date.now(),
    });
  }

  async deleteExpense(expense) {
    try {
      this.setAsyncState({
        visibleModal: null,
        modalData: null,
        deleting: true,
        error: null,
      });
      await api.delete("v1/expense/" + expense._id);
      this.setAsyncState({ deleting: false, triggerReload: Date.now() });
    } catch (e) {
      console.log(e.message);
      this.setAsyncState({ deleting: false, error: e.message });
    }
  }

  handleSearchQ(q) {
    if (q) {
      this.additionalQueries = {
        where: {
          $and: [
            {
              label: { $regex: q, $options: "i" },
            },
          ],
        },
      };
    } else {
      this.additionalQueries = null;
    }
    this.setAsyncState({ triggerReload: Date.now() });
  }

  render() {
    const {
      state: { visibleModal, modalData, triggerReload, error },
    } = this;

    const screen = (
      <div>
        <div className="pagetitlebar">
          <div className="left">
            <div className="title">Expenses</div>
          </div>
          <div className="right">
            <SearchBox onChange={this.handleSearchQ.bind(this)} />
            <Button
              onClick={() =>
                this.setAsyncState({
                  visibleModal: "editExpense",
                  modalData: null,
                })
              }
            >
              Add New Expense
            </Button>
          </div>
        </div>

        <div>
          <ItemList
            {...{
              defaultQuery: {},
              triggerReload,
              items: this.props.expenses,
              table: {
                columns: this.columns,
              },
              retriveData: this.retriveData.bind(this),
              setItems: this.setItems.bind(this),
              additionalQueries: this.additionalQueries,
            }}
          />
        </div>

        <EditExpense
          {...{
            key: `editExpense-${
              visibleModal === "editExpense"
                ? modalData?.expense?._id?.toString() || "new"
                : "disabled"
            }`,
            renderModal: true,
            visible: visibleModal === "editExpense",
            handleClose: () => this.setAsyncState({ visibleModal: null }),
            onSubmit: (item) => this.onNewExpense(item),
            ...(modalData || {}),
          }}
        />
        <ConfirmationModal
          visible={visibleModal === "deleteExpense"}
          title="Confirm Delete"
          body={`Are you sure you want to delete this expense of "${modalData?.expense?.label}"?`}
          onSubmit={() => this.deleteExpense(modalData?.expense)}
          handleClose={() =>
            this.setAsyncState({ visibleModal: null, modalData: null })
          }
          error={error}
        />
      </div>
    );

    return (
      <>
        <NavBar activeLink="/expense" />
        <Container className="gainner">{screen}</Container>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  expenses: state.vState[SCREEN_NAME]?.expenses || [],
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExpensesScreen);
